import getAPIResponse from "../common/Common";

/**
 * Fetch Player B health events from the backend.
 *
 * @param {object} options
 * @param {string} [options.publicPath]   Filter to one user's publicPath.
 * @param {string} [options.viewId]       Filter to one session viewId.
 * @param {string} [options.event]        Filter to one event name.
 * @param {string} [options.source]       Filter by source: backend, frontend, websocket.
 * @param {string} [options.level]        Filter by log level.
 * @param {string} [options.channelName]  Partial channel-name match.
 * @param {string} [options.since]        ISO-8601 lower bound.
 * @param {string} [options.until]        ISO-8601 upper bound.
 * @param {number} [options.limit=200]    Max events returned.
 * @param {boolean} [options.groupBySession=false] If true, returns sessions[].
 * @returns {Promise<{events?: Array, sessions?: Array, count: number, total: number, filters: object}|null>}
 */
export async function getPlayerHealth({
    publicPath,
    viewId,
    event,
    source,
    level,
    channelName,
    since,
    until,
    limit = 200,
    groupBySession = false,
    signal
} = {}) {
    const params = new URLSearchParams();
    if (publicPath) params.set('publicPath', publicPath);
    if (viewId)     params.set('viewId',     viewId);
    if (event)      params.set('event',      event);
    if (source)     params.set('source',     source);
    if (level)      params.set('level',      level);
    if (channelName) params.set('channelName', channelName);
    if (since)      params.set('since',      since);
    if (until)      params.set('until',      until);
    params.set('limit', String(limit));
    if (groupBySession) params.set('groupBy', 'session');
    const qs = params.toString();
    const url = `/api/v1/admin/player-health${qs ? '?' + qs : ''}`;
    return await getAPIResponse(url, {}, 'get', { signal });
}
